import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { RootState } from '../store'

const determineBaseUrl = () => {
  if (import.meta.env.VITE_RUN_ENV === 'local') {
    console.warn('Local endpoint')
    return 'http://localhost:8050'
  } else if (import.meta.env.VITE_RUN_ENV === 'staging') {
    return 'https://staging-nascc-backend.onrender.com'
  } else if (import.meta.env.VITE_RUN_ENV === 'production') {
    return 'https://production-nascc-backend.onrender.com'
  }
  // Default to local if no environment is set
  return 'http://localhost:8050'
}

export const emptyApi = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: determineBaseUrl(),
    prepareHeaders: (headers, { getState }) => {
      const authToken = (getState() as RootState).user.token
      if (authToken) {
        headers.set('Authorization', `Bearer ${authToken}`)
      }
      return headers
    }
  }),
  endpoints: () => ({}),
  tagTypes: [
    'User',
    'MemberCenter',
    'Subscriber',
    'CenterSubscribers',
    'CenterApplication',
    'CenterApplicationEvent'
  ]
})
